"use client";

import dynamic from "next/dynamic";

// Not needed for the first paint: load these in their own chunks after the page is interactive.
const Analytics = dynamic(() => import("@/components/analytics/Analytics").then((m) => m.Analytics), { ssr: false });
const CookieConsent = dynamic(() => import("@/components/cookie-consent/CookieConsent").then((m) => m.CookieConsent), { ssr: false });

export function DeferredWidgets() {
  return (
    <>
      <CookieConsent />
      <Analytics />
    </>
  );
}
